import { isEmpty } from 'lodash'
import { Grid } from '@mui/material'
import { ButtonV2 } from '@labrav/react-components'

import { useStyles } from './SelectedSubscriptionDetail.styles'
import { DetailedSubscription } from '../../DetailedSubscription/DetailedSubscription'
import { useSelector } from '../../../../store'
import type { SubscriptionDetailObject } from '../../../../modules/subscription/reducer'
import { dateAndTimeConversion } from '../../../../common/utils/dateAndTimeConversion'

export const SelectedSubscriptionDetail = ({
  handleModalOpen,
  selectedSubscription,
}: {
  handleModalOpen: () => void
  selectedSubscription: string
}) => {
  const { classes } = useStyles()

  const subscriptionDetail = useSelector<SubscriptionDetailObject>(
    state =>
      state?.subscriptions?.currentSubscription?.[selectedSubscription] || null
  )

  const emptySubscriptionContent = (
    <ButtonV2
      className={classes.selectanotherSubscription}
      styleType="link"
      onClick={handleModalOpen}
    >
      Select a contract
    </ButtonV2>
  )

  const timeZone = useSelector<string>(
    state =>
      state.userProfile.userProfile.timeZone ||
      state.userProfile.userProfile.defaultTimeZone ||
      'UTC'
  )

  const isSubscriptionExpirationDate =
    !isEmpty(subscriptionDetail) &&
    subscriptionDetail.subscription?.expirationDate

  const {
    modifiedDate: subscriptionExpiryDate,
    modifiedTime: subscriptionExpiryTime,
  } = isSubscriptionExpirationDate
    ? dateAndTimeConversion(
        subscriptionDetail.subscription?.expirationDate,
        timeZone
      )
    : { modifiedDate: '-', modifiedTime: '-' }

  const selectedSubscriptionContent = !isEmpty(subscriptionDetail) ? (
    <div
      className={classes.containerwrapper}
      data-testid={'selected-subscription'}
    >
      <div className={classes.containerwrapper}>
        <Grid container spacing={0} className={classes.rowContainer}>
          <Grid
            className={classes.oddColumn}
            size={{
              md: 6,
            }}
          >
            <DetailedSubscription
              label="Contract ID"
              value={subscriptionDetail.subscription.id || '-'}
            />
          </Grid>
          <Grid
            size={{
              md: 6,
            }}
          >
            <DetailedSubscription
              label="Contract expiration date"
              value={
                isSubscriptionExpirationDate ? subscriptionExpiryDate : '-'
              }
              subValue={
                isSubscriptionExpirationDate ? subscriptionExpiryTime : ''
              }
            />
          </Grid>
        </Grid>
        <Grid container spacing={0} className={classes.middleRowContainer}>
          <Grid
            className={classes.oddColumn}
            size={{
              md: 6,
            }}
          >
            <DetailedSubscription
              label="Offer name"
              value={subscriptionDetail.offerDetails.privateOfferName || '-'}
            />
          </Grid>
          <Grid
            size={{
              md: 6,
            }}
          >
            <DetailedSubscription
              label="Cloud offer ID"
              value={subscriptionDetail.offerDetails.cloudOfferId || '-'}
            />
          </Grid>
        </Grid>
        <Grid container spacing={0} className={classes.rowContainer}>
          <Grid
            className={classes.oddColumn}
            size={{
              md: 6,
            }}
          >
            <DetailedSubscription
              label="Company"
              value={subscriptionDetail.buyerDetails.companyName || '-'}
            />
          </Grid>
          <Grid
            size={{
              md: 6,
            }}
          >
            <DetailedSubscription
              label="Buyer AWS account number"
              value={subscriptionDetail.subscription.cloudAccountId || '-'}
            />
          </Grid>
        </Grid>
      </div>
      <ButtonV2
        className={classes.selectanotherSubscription}
        styleType="link"
        onClick={handleModalOpen}
        data-testid={'select-another'}
      >
        Select another contract
      </ButtonV2>
    </div>
  ) : (
    <></>
  )
  return isEmpty(selectedSubscription)
    ? emptySubscriptionContent
    : selectedSubscriptionContent
}
